module.exports = __webpack_public_path__ + "06ea27b87a7f5dca9db699d85a4cd818.webp";